import templateScorecard from '../../../../Template/config/components/scorecard';
import metricsLabels from './MetricsLabels';
import scorecardView from './ScorecardView';
import trendChart from './Trendchart';

export default {
  ...templateScorecard,
  maxAdsLength: 300,
  maxNormLength: 300,
  sampleSizeMetric: 121,
  sampleSizeThreshold: 40,
  hideMetricWithMissingNorm: false,
  sortMetric: 1,
  calcFlags: {
    ad: {
      includeAllHistory: true,
      excludeProprietary: false,
      monthIndependentData: true
    },
    norm: {
      includeAllHistory: true,
      excludeProprietary: true,
      excludeNonNorm: true,
      monthIndependentData: true,
      minSampleSize: 0
    }
  },
  metricsLabels,
  scorecardView,
  trendChart
};



// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/components/scorecard/index.js